import { useQuery } from '@tanstack/react-query';

import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { withError } from '@/react-tools/react-query';
import { EnvironmentId } from '@/react/portainer/environments/types';
import { ContainerId } from '@/react/docker/containers/types';

import { EdgeStack } from '../../edge-stacks/types';

type Props = {
  edgeStackId: EdgeStack['Id'];
  environmentId: EnvironmentId;
  containerId: ContainerId;
};

export function useAsyncContainerLogs(props: Props) {
  return useQuery(['logs'], () => getContainerLogs(props), {
    ...withError(),
  });
}

export async function getContainerLogs({
  edgeStackId,
  environmentId,
  containerId,
}: Props) {
  try {
    const { data } = await axios.get<string>(
      `/edge_stacks/${edgeStackId}/logs/${environmentId}/content`,
      {
        params: { container_id: containerId },
      }
    );
    return data;
  } catch (error) {
    throw parseAxiosError(error, 'Unable to retrieve async container logs');
  }
}
